import "./NursingCareProviderInHerzliyaWithinFiveHours.module.css";
import Header from "@/reusable_sections/Header";
import CareerInsightsHero from "./sections/CareerInsightsHero";
import LocationsAndPavilionsInHerzliya from "./sections/LocationsAndPavilionsInHerzliya";
import RelatedApps from "./sections/RelatedApps";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import ContactUs from "./sections/ContactUs";
import Footer from "@/reusable_sections/Footer";
export default function NursingCareProviderInHerzliyaWithinFiveHoursPage() {
  return <div>
      <Header />
      <CareerInsightsHero />
      <LocationsAndPavilionsInHerzliya />
      <RelatedApps />
      <FrequentlyAskedQuestions />
      <ContactUs />
      <Footer />
    </div>;
}